import { FunctionViewModel } from '../models/viewModels/FunctionViewModel';
export class ActionService {
    constructor() {
        this.actions = new FunctionViewModel();
        this.newFunction = true;
        this.state = '';
        this.isEditing = false;
    }
    getActions() {
        return this.actions;
    }
    setActions(actions) {
        this.actions = actions;
    }
    setStatusNewFunction(newFunction) {
        this.newFunction = newFunction;
    }
    getStatusNewFunction() {
        return this.newFunction;
    }
    setState(state) {
        this.state = state;
    }
    getState() {
        return this.state;
    }
    setAllFunctions(allFunctions) {
        this.allFunctions = allFunctions;
    }
    getAllFunctions() {
        return this.allFunctions;
    }
    setIsEditing(isEditing) {
        this.isEditing = isEditing;
    }
    getIsEditing() {
        return this.isEditing;
    }
    setApplication(application) {
        this.application = application;
    }
    getApplication() {
        return this.application;
    }
}
